import api from './api';
import {PressureReading, SuggestedTemperature} from '@/types/sensors';

export const sensorsService = {
  getCurrentPressure: async (): Promise<PressureReading> => {
    const response = await api.get<PressureReading>('/api/iot/pressure/current/');
    return response.data;
  },

  getSuggestedTemperature: async (): Promise<SuggestedTemperature> => {
    const response = await api.get<SuggestedTemperature>('/api/iot/temperature/suggested/');
    return response.data;
  },
};